export const BASE_URL = (window as any).env?.algonomy?.baseUrl || ''

export const endpoints = {
  getCartInfoUrl: () => `${BASE_URL}`
}
